import React from 'react'
import PropTypes from 'prop-types'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
// @material-ui/icons

// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'

import dashboardStyle from 'assets/jss/material-dashboard-pro-react/views/dashboardStyle'

// Apollo thingy
import { graphql, Query } from 'react-apollo'

// Replace the following 3 lines for different component
import { getSigningPath } from '../../queries/getSigningPathQuery'

import SigningPathTable from './SigningPathTable'
import SigningPathDetail from './SigningPathDetail'

/** 
Explaination of logic: 

1. apollo query is bound to this component, upon starting, the component retrieves data and pass it to the child of Table
   along with the data inject by qpl, there are 2 parameters pass into Table
   1) showEditProfile - handle the click on table
   2) getRefetchFunction - use to hold the 'refetch' function of qpl Query, so we can update Table view once the detail is updated
2. when a row in table is clicked, state.showDetail will be set to true which display the detail panel, and meantime the data is
   brought back from Table view as well and populate to this.state for updating
  
3. once the modified data is successfully saved, kill the detail panel and forceupdate table view as well
*/

const BuildTableView = props => {
  const { getRefetchFunction } = props
  return (
    <Query query={getSigningPath} errorPolicy="all" forceFetch={true} fetchPolicy="network-only">
      {apollocData => {
        const { loading, error, data, refetch } = apollocData
        getRefetchFunction(refetch)
        if (error) return <p >error</p>
        if (loading) {
          return <p>Loading...</p>
        } else {
          // console.log(data)
          return <SigningPathTable signingPaths={data.signingPaths} refetch={refetch} />
        }
      }}
    </Query>
  )
}
class SigningPathTableAndDetails extends React.Component {
  constructor(props) {
    super(props)

    this.getRefetchFunction = this.getRefetchFunction.bind(this)
  }
  state = {
    showDetail: false
  }

  getRefetchFunction(func) {
    this.forceUpdate = func
  }

  render() {
    // const { classes } = this.props

    return (
      <div>
        <GridContainer>
          <GridItem xs={12}>
            <BuildTableView getRefetchFunction={this.getRefetchFunction} />
          </GridItem>
        </GridContainer>
        {this.state.showDetail ? (
          <GridContainer>
            <GridItem xs={12}>
              <SigningPathDetail data={this.state.data} />
            </GridItem>
          </GridContainer>
        ) : (
            ''
          )}
      </div>
    )
  }
}

SigningPathTableAndDetails.propTypes = {
  classes: PropTypes.object.isRequired
}

export default graphql(getSigningPath)(withStyles(dashboardStyle)(SigningPathTableAndDetails))
